import React from "react";
import styles from "./IncomingCall.module.css";

const PhoneIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
    <path
      d="M6.6 10.8c1.44 2.83 3.77 5.15 6.6 6.6l2.2-2.2c.28-.28.68-.36 1.03-.25 1.13.37 2.35.57 3.6.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1C10.85 21 3 13.15 3 3.5 3 2.95 3.45 2.5 4 2.5H7.5c.55 0 1 .45 1 1 0 1.25.2 2.47.57 3.6.11.35.03.75-.25 1.03l-2.22 2.17Z"
      fill="#fff"
    />
  </svg>
);

const IncomingCall = ({ from, contactName, onAccept, onReject }) => (
  <div className={styles.screen}>
    <div className={styles.top}>
      <p className={styles.label}>Incoming call</p>
      <div className={styles.avatar}>
        <svg width="46" height="46" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="8" r="4" fill="rgba(255,255,255,0.9)" />
          <path
            d="M4 20c0-3.31 3.58-6 8-6s8 2.69 8 6"
            stroke="rgba(255,255,255,0.9)"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className={styles.number}>{contactName || from || "Unknown"}</div>
      {/* Ringing screen pe dropdown dikkat karta — naam mila to number seedha neeche. */}
      {contactName && from ? <p className={styles.subNumber}>{from}</p> : null}
    </div>

    <div className={styles.actions}>
      <button type="button" className={styles.rejectBtn} onClick={onReject} aria-label="Reject">
        <PhoneIcon />
      </button>
      <button type="button" className={styles.acceptBtn} onClick={onAccept} aria-label="Accept">
        <PhoneIcon />
      </button>
    </div>
  </div>
);

export default IncomingCall;
